// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dqvxf0_p_sseQ3M_Gv_g{display:flex;flex-direction:column;row-gap:20px;width:400px}`, "",{"version":3,"sources":["webpack://./modules/Admin/System/Session/SessionSettings.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,YAAA,CACA,WAAA","sourcesContent":[".form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  row-gap: 20px;\r\n  width: 400px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `Dqvxf0_p_sseQ3M_Gv_g`
};
export default ___CSS_LOADER_EXPORT___;
